import AuthenticationLayout from "./AuthenticationLayout";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuthStore } from "../stores";
import AppLayout from "./AppLayout";
import { useEffect } from "react";
import { SVGs } from "../assets";
import SubRouteLayout from "./SubRouteLayout";
import RequireNavigationData from "./RequireNavigationData";
import UnauthenticatedRedirect from "./UnauthenticatedRedirect";
import { Constants } from "../utils";
import {
  Booking,
  BookingDetail,
  Dashboard,
  EmailVerification,
  Login,
  ManageBookings,
  Payment,
} from "../screens";

export default function AppRoutes() {
  const initialize = useAuthStore((s) => s.initialize);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    initialize();
  }, [initialize]);

  if (isAuthenticated === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <SVGs.Spinner className="w-10 h-10 animate-spin" />
      </div>
    );
  }

  return (
    <Routes>
      {isAuthenticated ? (
        <>
          <Route element={<AppLayout />}>
            <Route index element={<Dashboard />} />
            <Route
              path={Constants.RoutePath.ManageBookings}
              element={<ManageBookings />}
            />
            <Route element={<SubRouteLayout />}>
              <Route
                path={Constants.RoutePath.BookingDetail}
                element={<BookingDetail />}
              />
              <Route element={<RequireNavigationData />}>
                <Route
                  path={Constants.RoutePath.Booking}
                  element={<Booking />}
                />
                <Route
                  path={Constants.RoutePath.BookingPayment}
                  element={<Payment />}
                />
              </Route>
            </Route>
          </Route>
          <Route
            path="*"
            element={<Navigate to={Constants.RoutePath.Dashboard} replace />}
          />
        </>
      ) : (
        <>
          <Route element={<AuthenticationLayout />}>
            <Route index element={<Login />} />
            <Route
              path={Constants.RoutePath.VerifyEmail}
              element={<EmailVerification />}
            />
          </Route>
          <Route path="*" element={<UnauthenticatedRedirect />} />
        </>
      )}
    </Routes>
  );
}
